<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Подписан ЮЛ</div>
            <div class="dx-field-value">
                <dx-date-box :value="data?.sign_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('data');
</script>
